

const ACTIVE_SERVER = {
    serverAddress: "https://trade.rashac.com",
    serverName: 'Rashticle'
}

export default ACTIVE_SERVER;
